import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LoadError, errMessage } from "@/components/LoadError";
import { BezoekLezen } from "./BezoekLezen";
import { BezoekBewerken } from "./BezoekBewerken";

// Laadt één bezoek; de auteur (OM-identiteit) bewerkt, iedereen anders leest. `alleenLezen` dwingt lezen af (dossier).
export const BezoekInhoud = ({ id, alleenLezen = false, onGeladen }) => {
  const { user } = useAuth();
  const [b, setB] = useState(null);
  const [fout, setFout] = useState("");
  const laad = useCallback(() => {
    setFout("");
    api.get(`/bezoeken/${id}`).then((r) => { setB(r.data); onGeladen?.(r.data); }).catch((e) => setFout(errMessage(e)));
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { setB(null); laad(); }, [laad]);

  if (fout) return <LoadError error={fout} onRetry={laad} testid="bezoek-load-error" />;
  if (!b) return <p data-testid="bezoek-laden" className="text-sm text-zinc-400 py-6">Laden…</p>;
  const auteur = b.om === user.username && (user.role === "om" || user.role === "oversight");
  return auteur && !alleenLezen ? <BezoekBewerken key={b.id} start={b} /> : <BezoekLezen b={b} />;
};
